/**
 * Sidebar "Yeni" rozeti için saf yardımcı (#770).
 *
 * Bir nav item, `newUntil` (ISO tarih, 'YYYY-MM-DD') o günün SONUNA kadar
 * (dahil) Europe/Istanbul saatine göre "yeni" sayılır. Ziyaret edilmesi
 * rozeti KAPATMAZ — yalnızca tarih kontrol eder (saf fonksiyon, side-effect yok).
 *
 * Türkiye 2016'dan beri yaz saati uygulamıyor, UTC+03:00 sabit (IANA
 * Europe/Istanbul) — bu yüzden gün sonu anını hesaplamak için tam bir
 * zaman dilimi kütüphanesine gerek yok: İstanbul'da 23:59:59.999,
 * UTC'de aynı takvim gününün 20:59:59.999'una denk gelir.
 */
const ISTANBUL_UTC_OFFSET_HOURS = 3

const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/

/**
 * `newUntil` tarihi geçerliyse ve `now` o tarihin (İstanbul, gün sonu dahil)
 * içindeyse `true` döner. `newUntil` tanımsız/boş/geçersiz formatta ise `false`.
 */
export function isNavItemNew(newUntil: string | undefined | null, now: Date = new Date()): boolean {
  if (!newUntil) return false

  const match = ISO_DATE_RE.exec(newUntil)
  if (!match) return false

  const [, yearStr, monthStr, dayStr] = match
  const year = Number(yearStr)
  const month = Number(monthStr)
  const day = Number(dayStr)

  const endOfDayUtcMs = Date.UTC(
    year,
    month - 1,
    day,
    23 - ISTANBUL_UTC_OFFSET_HOURS,
    59,
    59,
    999,
  )

  if (Number.isNaN(endOfDayUtcMs)) return false

  return now.getTime() <= endOfDayUtcMs
}
